/* Hammock Hut: restore collection position after viewing a product */
(() => {
  const KEY = 'hhCollectionReturn';

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href*="/products/"]');
    if (!link || !location.pathname.startsWith('/collections/')) return;

    const card = link.closest('.card-wrapper, .grid__item, li') || link;
    if (!card.id) card.id = 'hh-product-' + Math.random().toString(36).slice(2);

    sessionStorage.setItem(KEY, JSON.stringify({
      collectionUrl: location.pathname + location.search,
      productPath: new URL(link.href, location.origin).pathname,
      anchorId: card.id,
      scrollY: window.scrollY,
      savedAt: Date.now()
    }));
  }, true);

  const restore = () => {
    if (!location.pathname.startsWith('/collections/')) return;
    let state;
    try { state = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (_) {}
    if (!state || state.collectionUrl !== location.pathname + location.search) return;
    if (Date.now() - state.savedAt > 30 * 60 * 1000) {
      sessionStorage.removeItem(KEY);
      return;
    }

    const anchor = state.anchorId && document.getElementById(state.anchorId);
    requestAnimationFrame(() => {
      if (anchor) {
        anchor.scrollIntoView({ block: 'center' });
      } else if (Number.isFinite(state.scrollY)) {
        window.scrollTo(0, state.scrollY);
      }
      setTimeout(() => {
        if (!anchor && Number.isFinite(state.scrollY)) window.scrollTo(0, state.scrollY);
        sessionStorage.removeItem(KEY);
      }, 250);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restore, { once: true });
  } else {
    restore();
  }
})();